<dv-dialog-content>
  <dv-dynamic-form
    class="dynamic-form"
    [elements]="[reportNameElement] | translateElements"
    [formGroup]="formGroup">
  </dv-dynamic-form>
  <dv-button footer-right (click)="cancel()">
    {{ 'General.Cancel' | translate }}
  </dv-button>
  <dv-button
    footer-right
    color="secondary"
    (click)="performSave()"
    [disabled]="!formGroup.valid || !formGroup.dirty">
    {{ 'General.Save' | translate }}
  </dv-button>
</dv-dialog-content>
